import React from 'react';
import { Bug16 } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuListItem,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';
import { useDisableTaskOutlineQuery } from 'shared/hooks/queries/use-disable-task-outline-query';
import { useSetDisableTaskOutlineMutation } from 'shared/hooks/queries/use-set-disable-task-outline-mutation';

export const OutlineOption: React.FC = () => {
  const { data: isOutlineDisabled } = useDisableTaskOutlineQuery();
  const { mutate } = useSetDisableTaskOutlineMutation();

  const toggleOutline = () => mutate(!isOutlineDisabled);

  return (
    <PopupMenuListItem>
      <PopupMenuToggle
        start={<Icon icon={Bug16} />}
        label="Task render outline"
        onChange={toggleOutline}
        checked={!isOutlineDisabled}
      />
    </PopupMenuListItem>
  );
};
